import CourseMixin from '@/mixins/templates/course';
import CommonMixin from '@/mixins/templates/common';

export default {
  name   : 'PendingApprovalBanner',
  mixins : [CourseMixin, CommonMixin],
  props  : {
    academicMainId: {
      type: Number
    },
    academicMainTypeId: {
      type: Number
    }
  }
};
